export function isMissingFileError(error: unknown): boolean {
  const message =
    typeof error === "object" && error !== null
      ? (error as { message?: unknown }).message
      : null;

  return typeof message === "string" && message.includes("does not exist");
}
